<template>
  <file-uploader :url="url"
    :name="name"
    :params="params"
    :ref="singleMediaRef"
    :transmit-ref="transmitRef"
    v-bind="options"

    @processing="handleProcessing"
    @success="handleSuccess"
    @error="handleError">

    <div
      :class="{
        'single-media-input d-flex align-items-center justify-content-center': true,
        'alert-danger': hasError(name)
      }"
      @click="triggerBrowse">
      <preloader :show="processing">
        <slot name="mask"></slot>

        <img class="media-preview" :src="source.url || placeholder" :alt="alt" />
      </preloader>
    </div>
  </file-uploader>
</template>

<script>
  import { assign } from 'lodash'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    data () {
      return {
        processing: false,
        transmitRef: '',
        singleMediaOptions: {
          acceptedFileTypes: ['image/*'],
          clickable: false
        }
      }
    },

    props: {
      name: {
        type: String,
        default: 'media'
      },

      singleMediaRef: {
        type: String,
        default: 'SingleMediaRef'
      },

      url: {
        type: String,
        required: true
      },

      placeholder: {
        type: String,
        default: ''
      },

      collection: {
        type: String,
        default: 'default'
      },

      fields: {
        type: Object,
        default () { return {} }
      },

      source: {
        type: Object,
        default: () => {}
      },

      alt: {
        type: String,
        default: ''
      }
    },

    computed: {
      ...mapGetters({
        getError: 'errors/getError',
        hasError: 'errors/hasError'
      }),

      options () {
        return assign(this.singleMediaOptions, {
          url: this.url
        })
      },

      params () {
        return assign(this.fields, {
          collection: this.collection
        })
      }
    },

    methods: {
      ...mapActions({
        clearError: 'errors/clearError'
      }),

      triggerBrowse () {
        if (this.processing === false) {
          this.$refs[this.singleMediaRef]
            .$refs[this.transmitRef]
            .triggerBrowseFiles()
        }
      },

      handleSuccess () {
        this.$nextTick(() => {
          this.clearError([this.name])
          this.processing = false
        })

        this.$emit('success', arguments[0], arguments[1], arguments[2])
      },

      handleError () {
        this.$nextTick(() => { this.processing = false })

        this.$emit('error', arguments[0], arguments[1], arguments[2])
      },

      handleProcessing () {
        this.processing = true
        this.clearError([this.name])

        this.$emit('processing', arguments[0])
      }
    },

    created () {
      this.transmitRef = this.singleMediaRef + Math.random().toString(36).substr(2, 5)
    }
  }
</script>

<style lang="sass">
  .single-media-input
    cursor: pointer;
    background-color: #eee
    border: #ccc 1px solid
    font-family: 'Arial', sans-serif
    letter-spacing: 0.2px
    color: #777
    transition: background-color .2s linear
    min-height: 150px
    max-height: 250px
    padding: 2px

    .media-preview
      max-width: 100%;
      width: auto;
      max-height: 250px;

    &.alert-danger
      color: #813838
      background-color: #fee2e1
      border-color: #fdd6d6
</style>



// WEBPACK FOOTER //
// src/components/ui/SingleMediaUploader.vue